import {ReactNode} from 'react';
import * as css from './TicketCard.css';
import {tickchakLogo} from '../../../assets/symbols/images/Images.css';

interface FooterLink {
    label: string;
    href: string;
}

interface TicketCardProps {
    top?: ReactNode;
    children: ReactNode;
    footerLink?: FooterLink;
    'data-cy'?: string;
}

function TicketCard({top, children, footerLink, 'data-cy': dataCy = 'ticket-card'}: TicketCardProps) {
    return (
        <css.cardInner data-cy={dataCy}>
            {top && <css.top>{top}</css.top>}
            <css.middle>{children}</css.middle>
            <css.footer className={footerLink ? 'with-link' : ''}>
                {footerLink && (
                    <css.terms
                        href={footerLink.href}
                        target="_blank"
                        rel="noreferrer"
                        data-cy="ticket-card-terms">
                        {footerLink.label}
                    </css.terms>
                )}
                <css.logo src={tickchakLogo} alt="Tickchak" />
            </css.footer>
        </css.cardInner>
    );
}

export default TicketCard;
